/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
export class OrderGetDto {
  constructor(order) {
    this.codigoPedido = order['Código Pedido'] || "",
    this.codigoCliente = order['Código Cliente'] || "",
    this.cliente = order["Cliente"] || "",
    this.codigoPuntoVenta = order['Código Punto de Venta'] || "",
    this.puntoVenta = order["Punto de Venta"] || "",
    this.solicitante = order["Solicitante"] || "",    
    this.producto = order["Producto"]
    this.codigoEAN = order["Código EAN"] || "",
    this.descripcion = order["Descripcion Producto"] || "",
    this.cantidad = order["Cantidad"] || "",
    this.facturaCliente = order["Factura Cliente"] || "",
    this.tipoPedido = order["Tipo Pedido"] || "",
    this.precioTotal = order["Precio total"] || "",
    this.fechaPedido = order["Fecha Pedido"] || "",
    this.fechaPromesa = order["Fecha Promesa"] || "",
    this.fechaEnvio = order["Fecha Envio"] || "",
    this.fechaEntrega = order["Fecha Entrega"] || "",
    this.fechaDespacho = order["Fecha Despacho"] || "",
    this.fechaCreacion = order["Fecha Creación"] || "",
    this.observaciones = order["Observaciones"] || "",
    this.estado = order["Estado Orden"] ? order["Estado Orden"].toUpperCase() : "",
    this.ultimoEvento = order["Ultimo Evento"] ? order["Ultimo Evento"].toUpperCase() : "",
    this.causa = order["Causa Actual"] || "",
    this.notaTransporte = order["Nota Transporte"] || "",
    this.camion = order["Camión"] || "",
    this.numeroGuia = order["Número Guía"] || "",    
    this.cedula = order["Cédula SubCliente"] || "",
    this.nombreSubCliente = order["Nombre SubCliente"] ? order["Nombre SubCliente"].toUpperCase() : "",
    this.telefono1SubCliente = order["Télefono 1 Subcliente"] || "",
    this.telefono2SubCliente = order["Télefono 2 Subcliente"] || "",
    this.direccionSubCliente = order["Dirección Subcliente"] || "",
    this.barrioSubCliente = order["Barrio Subcliente"] || "",
    this.codigoMunicipio = order['Código Municipio'] || "",
    this.municipioSubCliente = order["Municipio Subcliente"] || "",
    this.departamento = order['Departamento'] || "",
    this.tirilla = order["Tirilla"] || "",
    this.transportista = order["Transportista"] || "",
    this.referencia = order["Referencia"] || "",    
    this.ultimaLlamada = order["Ultima llamada"] || ""
  }
}